/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithIsActiveItemRequestBuilder, WithIsActiveItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AircraftType/{id}
 */
export interface AircraftTypeItemRequestBuilder extends BaseRequestBuilder<AircraftTypeItemRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.AircraftType.item.item collection
     * @param isActive Unique identifier of the item
     * @returns {WithIsActiveItemRequestBuilder}
     */
     byIsActive(isActive: boolean) : WithIsActiveItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AircraftTypeItemRequestBuilderUriTemplate = "{+baseurl}/AircraftType/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AircraftTypeItemRequestBuilderNavigationMetadata: Record<Exclude<keyof AircraftTypeItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byIsActive: {
        requestsMetadata: WithIsActiveItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["isActive"],
    },
};
/* tslint:enable */
/* eslint-enable */
